import axios from 'axios'
import {chargeBackHost, envBackHost, envImagePath, hdmBackHost} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import {globalFormatWithHyphens} from 'utils/const/globalConst'
import _ from 'lodash'
import {
  confirmAlert,
  confirmASAlert,
  confirmTextAlert,
  ErrorAlert,
  noDataAlert,
  noNewImageAlert,
  normalAlert,
  resultAlert,
  SuccessAlert,
} from 'utils/CustomAlert/Alert'

const apiKey = process.env.REACT_APP_WEATHER_API_KEY
/**
 * Interface
 */
interface Callbacks {
  success: (data: any) => void // API 응답 데이터의 타입을 `any` 대신 구체적인 타입으로 교체해야 합니다.
  fail: (error: any) => void // 오류 객체의 타입을 `any` 대신 구체적인 타입으로 교체해야 합니다.
  loading?: any
  count?: any
}

/**
 * MAP`s API
 */
export const getMarker = async (
  officeInfo: any,
  cooperInfo: any,
  setCluster: any,
  setCity: any
) => {
  try {
    // 로딩 시작
    const response = await axiosWithAuth().get(
      `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/dashboard/marker`
    )

    // 데이터가 유효한지 확인 (예: 배열인지 확인)
    if (Array.isArray(response.data.res.customerClusterModelList)) {
      setCluster(response.data.res.customerClusterModelList)
      setCity(response.data.res.cityAndDistrictModel)
    } else {
      console.error('Invalid data format: expected an array')
    }
  } catch (error) {
    console.error('GET dashboard Info', error)
  } finally {
    // 로딩 끝
    return
  }
}

export const getWeather = (setApiData: any) => {
  fetch(
    `https://api.openweathermap.org/data/2.5/weather?q=seoul&lang=kr&&appid=${apiKey}&units=metric`
  )
    .then((res) => res.json())
    .then((data) => {
      setApiData(data)
    })
}
/**
 * Device API
 */
export const serverCycleChange = async (
  user: any,
  target: any,
  value: number,
  {success, fail}: Callbacks
) => {
  try {
    const response = await axiosWithAuth().post(`${envBackHost}/office/device/cycle`, {
      officeId: target.officeId,
      cycle: value,
      requestId: user.id,
    })
    success(response.data)
    await resultAlert(response.data)
  } catch (error: any) {
    fail(error)
    await resultAlert({resultCode: error.response.status})
  }
}
export const getDeviceCheckList = async (
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/${cooper?.value}/device/check`, {
      params: {
        url: filter.url,
        searchOption: filter.searchOption,
        searchData: filter.searchData,
        checkStatus: filter.checkStatus,
        startDate: filter.startDate,
        endDate: filter.endDate,
        page: filter.page,
        rowPerPage: filter.rowPerPage,
      },
    })
    success(response.data.res)
    count(response.data.count)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const getDeviceAssignList = async (
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/${cooper?.value}/device/assign`, {
      params: {
        url: filter.url,
        searchOption: filter.searchOption,
        searchData: filter.searchData,
        assignStatus: filter.assignStatus,
        page: filter.page,
        rowPerPage: filter.rowPerPage,
      },
    })
    success(response.data.res)
    count(response.data.count)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}

export const checkButtonHandler = async (
  type: string,
  data: any,
  user: any,
  {success, fail, loading}: Callbacks
) => {
  if (data.length <= 0) {
    await noDataAlert()
    loading(false)
    return
  }
  if (await confirmAlert(type === 'delete' ? '삭제' : type, 'info')) {
    switch (type) {
      case 'pass':
        if (_.find(data, (el) => el.checkStatus === true)) {
          await normalAlert('이미 승인된 단말기가 존재합니다.')
          return
        }
        loading(true)
        try {
          const response = await axiosWithAuth().post(`${envBackHost}/device/check/${type}`, {
            device: data,
            id: user.userId,
          })
          if (response.data.resultCode === 0) {
            await resultAlert(response.data)
            success(response.data)
          }
        } catch (error: any) {
          fail(error)
          await resultAlert({resultCode: error.response.status})
        } finally {
          loading(false)
        }
        break
      case 'fail':
        loading(true)
        try {
          const response = await axiosWithAuth().post(`${envBackHost}/device/check/${type}`, {
            device: data,
            id: null,
          })
          if (response.data.resultCode === 0) {
            await resultAlert(response.data)
            success(response.data)
          }
        } catch (error: any) {
          fail(error)
          await resultAlert({resultCode: error.response.status})
        } finally {
          loading(false)
        }
        break

      case 'delete':
        loading(true)
        try {
          const response = await axiosWithAuth().post(`${envBackHost}/device/deletelist`, {
            device: data,
          })
          if (response.data.resultCode === 0) {
            await resultAlert(response.data)
            success(response.data)
          }
        } catch (error: any) {
          fail(error)
          await resultAlert({resultCode: error.response.status})
        } finally {
          loading(false)
        }
        break
    }
  } else return
}

export const allocationCancelHandler = async (data: any, {success, fail, loading}: Callbacks) => {
  if (data.length <= 0) {
    await noDataAlert()
    loading(false)
    return
  }
  if (_.find(data, (el) => el.assignToId === null)) {
    await normalAlert('할당이 진행되지 않은 단말기가 존재합니다.')
    return
  }
  if (await confirmAlert('할당취소', 'info')) {
    loading(true)
    try {
      const response = await axiosWithAuth().post(`${envBackHost}/device/assign/unassigned`, {
        device: data,
        fromId: null,
        toId: null,
      })
      if (response.data.resultCode === 0) {
        await resultAlert(response.data)
        success(response.data)
      }
    } catch (error: any) {
      fail(error)
      await resultAlert({resultCode: error.response.status})
    } finally {
      loading(false)
    }
  } else return
}
export const getDeviceInfo = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper.value
      }/device/installinfo`,
      {
        params: filter,
      }
    )
    success(response.data.res)
    count(response.data.count)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const getDeviceImages = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/checkmeter/list`,
      {
        params: filter,
      }
    )
    success(response.data.res)
    count(response.data.count)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}

/**
 * Customer API
 */
export const registerCustomer = async (values: any, reset: any) => {
  await axiosWithAuth()
    .post(`${envBackHost}/customer`, values)
    .then(async (res) => {
      if (res.data.resultCode === 0) {
        await resultAlert(res.data)
        reset()
      } else {
        /* res 가 비어 오면 resultCode 별 기본 안내가 나오도록 undefined 로 넘긴다
           (빈 문자열을 그대로 넘기면 '실패' 제목만 뜨고 사유가 가려진다) */
        await resultAlert(res.data, res.data.res || undefined)
      }
    })
    .catch(async (e) => {
      await resultAlert({resultCode: e?.response?.status})
    })
}
export const getAllocationList1 = async (info: any, filter: any, callback: any) => {
  await axiosWithAuth()
    .get(`${envBackHost}/${info?.value}/customer/assign`, {
      params: filter,
    })
    .then((res) => {
      callback(res.data.res)
    })
}
export const getAllocationList = async (office: any, filter: any, {success, fail}: Callbacks) => {
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/${office?.value}/customer/assign`, {
      params: filter,
    })
    success(response.data.res)
  } catch (error) {
    fail(error)
  } finally {
  }
}
export const cancelCustomerAllocation = async (info: any, data: any, callbacks: any) => {
  await axiosWithAuth()
    .post(`${envBackHost}/${info?.value}/customer/assign/unassigned`, data)
    .then(async (res) => {
      await resultAlert(res.data)
      if (res.data.resultCode === 0) {
        callbacks.forEach((callback: any) => {
          if (typeof callback === 'function') {
            callback()
          }
        })
      }
    })
    .catch(async (e) => {
      await resultAlert({resultCode: e.response.status})
    })
}
export const changeInstallStatus = async (info: any, data: any) => {
  try {
    if (await confirmAlert('설치가능', 'info')) {
      const response = await axiosWithAuth().post(
        `${envBackHost}/${info?.value}/customer/available`,
        data
      )

      if (response.data.resultCode === 0) {
        await resultAlert(response.data)
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } catch (e: any) {
    await resultAlert({resultCode: e.response.status})
    return false
  }
}
export const deleteCustomerAllocation = async (data: any, callbacks: any) => {
  if (data?.length === 0) {
    await noDataAlert()
    return
  }
  if (await confirmAlert('삭제', 'info')) {
    axiosWithAuth()
      .post(`${envBackHost}/customer/delete`, {
        customer: data,
      })
      .then(async (res) => {
        await resultAlert(res.data)
        if (res.data.resultCode === 0) {
          callbacks.forEach((callback: any) => {
            if (typeof callback === 'function') {
              callback()
            }
          })
        }
      })
      .catch(async (e) => {
        await resultAlert({resultCode: e.response.status})
      })
  } else {
    return
  }
}
export const getCustomerList = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(
      `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/customer/info/overview`,
      {
        params: filter,
      }
    )
    onSuccess(res.data.res, res.data.count)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

export const getCustomerNewList = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(
      `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/customer/info`,
      {
        params: filter,
      }
    )
    onSuccess(res.data.res, res.data.count)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

export const getCustomerIssueList = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(`${envBackHost}/customer-issues`, {
      params: {
        ...filter,
        officeId: officeInfo?.value === 'yit' ? 'all' : officeInfo?.value,
        cooperIdx: cooperInfo?.value,
        // 백엔드는 issueTypes를 쉼표로 구분된 문자열로 받음 (예: "A,B")
        issueTypes: filter?.issueTypes?.length ? filter.issueTypes.join(',') : undefined,
      },
    })
    onSuccess(res.data.res.customerIssues, res.data.res.issueCounts, res.data.count)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

export const getCustomerIssueCheckmeters = async (
  officeId: any,
  customerNumber: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(`${envBackHost}/customer-issue/checkmeters`, {
      params: {
        ...filter,
        officeId,
        customerNumber,
      },
    })
    onSuccess(res.data.res)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

export const getCustomerBinaryCheckList = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(
      `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/customer/image-verify`,
      {
        params: filter,
      }
    )
    onSuccess(res.data.res, res.data.count)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

export const getCustomerStatusList = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(
      `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/customer/overview`,
      {
        params: filter,
      }
    )
    onSuccess(res.data.res, res.data.count)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

export const getCustomerHdmList = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(
      `${hdmBackHost}/api/select/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/customer/hdm`,
      {
        params: filter,
      }
    )

    onSuccess(res.data.data, res.data.count)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

export const getVisibleHdmList = async () => {
  try {
    const res = await axiosWithAuth().get(`${hdmBackHost}/api/select/visible/list`)

    const result = {data: res.data.data, count: res.data.count}

    return result
  } catch (error) {}
}

export const getPhotoCustomerList = async (
  officeInfo: any,
  cooperInfo: any,
  filter: any,
  onSuccess: any,
  onError: any,
  onLoading: any
) => {
  try {
    onLoading(true)
    const res = await axiosWithAuth().get(
      `${envBackHost}/${officeInfo?.value === 'yit' ? 'all' : officeInfo?.value}/${
        cooperInfo?.value
      }/customer/photo`,
      {
        params: filter,
      }
    )
    onSuccess(res.data.res, res.data.count)
  } catch (error) {
    onError(error)
  } finally {
    onLoading(false)
  }
}

/**
 * Office API
 */
export const getOfficeList = async (userInfo: any, callBack: any) => {
  axiosWithAuth()
    .get(`/office/${userInfo?.officeId}`)
    .then((res: any) => {
      const data = res.data.res
      const transformedData = data.map((el: any) => ({
        label: el?.officeName,
        value: el?.officeId,
      }))
      callBack((prev: any[]) => [...(prev || []), ...transformedData])
    })
    .catch(async (err) => {
      await resultAlert({resultCode: err.response.status})
    })
}

export const getWorkTypeList = async (userInfo: any, callBack: any) => {
  axiosWithAuth()
    .get(`/office/${userInfo?.officeId}/customerworktype`)
    .then((res) => {
      callBack(res.data.res)
    })
    .catch(async (e) => {
      await resultAlert({resultCode: e.response.status})
    })
}
export const getCustomerTypeList = async (userInfo: any, callBack: any) => {
  axiosWithAuth()
    .get(`/office/${userInfo?.officeId}/customertype`)
    .then((res) => {
      callBack(res.data.res)
    })
    .catch(async (e) => {
      await resultAlert({resultCode: e.response.status})
    })
}
export const getMonitoringList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/monitoring`,
      {params: filter}
    )
    success(response?.data?.res)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}

export const getCheckList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/imagelist`,
      {
        params: filter,
      }
    )
    count(response?.data?.count)
    success(response?.data?.res)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const getCheckListChart = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/useinfo`,
      {
        params: filter,
      }
    )
    success(response?.data?.res)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const deleteCustomerList = async (data: any, {success, fail, loading}: Callbacks) => {
  if (data.length === 0) {
    await noDataAlert()
    return
  } else if (data?.length > 1) {
    await normalAlert('수용가 삭제는 1개씩만 가능합니다.')
    return
  } else if (data[0].customerStatus === 'as') {
    await normalAlert('AS가 진행 중인 수용가는 삭제할 수 없습니다.')
    return
  }
  if (await confirmAlert('삭제', 'info')) {
    try {
      loading(true)
      const response = await axiosWithAuth().delete(
        `${envBackHost}/${data[0]?.officeId}/customer/${data[0]?.customerNumber}`
      )
      success(response.data.res)
      await resultAlert(response.data)
    } catch (e) {
      fail(e)
    } finally {
      loading(false)
    }
  } else return
}
export const getCheckReportList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/checkreport`,
      {
        params: filter,
      }
    )
    count(response?.data?.count)
    success(response?.data?.res)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const checkValueUpdate = async (data: any, {success, fail, loading}: Callbacks) => {
  loading(true)
  if (data?.value === null && data?.startValue === null) {
    await normalAlert('수정할 검침값을 입력해주세요.')
    loading(false)
    return
  }
  if (await confirmAlert('수정', 'info')) {
    try {
      const response = await axiosWithAuth().post(`${envBackHost}/checkmeter/update`, data)

      await resultAlert(response.data)
      success(response.data)
    } catch (error) {
      fail(error)
    } finally {
      loading(false)
    }
  } else {
    loading(false)
    return
  }
}
export const getClientInfo = async (
  office: any,
  data: any,
  {success, fail, loading}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().post(`${envBackHost}/${office?.value}/client`, data)
    success(response.data.res)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}
export const getMinimumFlowList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/minimumflow`,
      {
        params: filter,
      }
    )
    success(response.data.res)
    count(response.data.count)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}

export const getNewLeakList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/leak/refactoring/v3`,
      {
        params: filter,
      }
    )
    success(response.data.res)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}
export const getNewLeakListCount = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/leak/refactoring/v3/count`,
      {
        params: filter,
      }
    )
    count(response.data.res)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}

export const getLeakListUncertainAll = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/leakTemp/uncertain`,
      {
        params: filter,
      }
    )
    success(response.data.res)
    count(response.data.count)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}
export const getLeakListUncertainUser = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/leakTemp/uncertain/customer`,
      {
        params: filter,
      }
    )
    success(response.data.res)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}

export const getLongTermUnusedList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/longtermunused`,
      {
        params: filter,
      }
    )

    success(response.data.res)
    count(response.data.count)
    loading(false)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}

export const getFreezeWarningList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/${
        cooper?.value
      }/customer/freeze-warning`,
      {
        params: filter,
      }
    )
    success(response.data.res)
    count(response.data.count)
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}

/**
 * Login API
 */
export const certifitaionRequest = async (data: any, {success, fail}: Callbacks) => {
  try {
    const response = await axios.post(`${envBackHost}/change/password/check`, data)
    success(response.data.res)
  } catch (e) {
    fail(e)
  }
}
export const passwordChangeRequest = async (data: any, {success, fail}: Callbacks) => {
  try {
    const response = await axios.post(`${envBackHost}/change/password`, {
      id: data.id,
      password: data.password, //feature/sc
      token: data.token,
    })
    success(response.data)
  } catch (e) {
    fail(e)
  }
}
/**
 * AS API
 */
export const getAsCauseList = async (callback: any) => {
  await axiosWithAuth()
    .get(`${envBackHost}/worktype/as/codetype/cause`)
    .then((res) => {
      callback(res.data.res)
    })
}

export const getAsCauseListT = async () => {
  await axiosWithAuth()
    .get(`${envBackHost}/worktype/as/codetype/cause`)
    .then((res) => {
      return res
    })
}

/**
 * A/S 진행 중 판정.
 * 기존 코드는 `typeof asIdx === 'string'`으로 판단해 asIdx가 숫자로 내려오면 가드를 통과했고,
 * 행 단위 A/S 버튼은 customerStatus === 'as'를 기준으로 삼아 기준이 둘로 갈려 있었다.
 * asIdx는 A/S 완료 후에도 값이 남을 수 있어(= 재등록이 막힘) 판정에 쓰지 않는다.
 * 화면에 표시되는 상태와 동일하게 customerStatus만 기준으로 삼는다.
 */
export const isAsInProgress = (row: any) => row?.customerStatus === 'as'

/**
 * A/S 등록(POST /as) 요청에 실을 필드. 백엔드가 지정한 형식이다.
 */
const AS_REGISTER_FIELDS = ['officeId', 'customerNumber', 'imei', 'imageIdxDate']

export const toAsRegisterTarget = (row: any) => _.pick(row, AS_REGISTER_FIELDS)

/**
 * A/S 취소(PUT /as/delete) 요청에 실을 필드.
 *
 * 기존에는 DataGrid 행 객체(CustomerInfo 기준 94개 필드)를 통째로 보냈다.
 * 사진 경로·좌표·이미지 보정값처럼 A/S와 무관한 값이 선택 건수만큼 실려 나간다.
 *
 * 아래 12개는 이 엔드포인트를 호출하는 모든 화면의 행 구조 교집합이다.
 * (AS관리 화면이 이 12개만 담긴 행으로 이미 성공하고 있으므로 서버가 필수로
 *  읽는 필드는 이 범위를 넘을 수 없다.)
 * 식별자 3개(officeId/customerNumber/asIdx)까지 줄이면 서버가 resultCode 30으로
 * 거부하므로 12개가 하한이다. 등록·취소 모두 브라우저에서 확인했다.
 */
const AS_TARGET_FIELDS = [
  'asIdx',
  'customerNumber',
  'customerName',
  'officeId',
  'officeName',
  'imei',
  'serialNumber',
  'deviceType',
  'deviceTypeName',
  'installerName',
  'phoneNumber',
  'id',
]

export const toAsTarget = (row: any) => _.pick(row, AS_TARGET_FIELDS)

/** 행 단위 A/S 확인창에 표시할 대상 수용가 (번호 + 이름) */
/** 확인창 문구에 쓸 대상 표기. 1건이면 수용가, 여러 건이면 건수 */
const asTargetText = (rows: any[]) =>
  rows.length === 1 ? asTargetLabel(rows[0]) : `선택한 수용가 ${rows.length}건`

export const asTargetLabel = (row: any) => {
  const escape = (value: any) =>
    String(value ?? '').replace(
      /[<>&]/g,
      (c) => ({'<': '&lt;', '>': '&gt;', '&': '&amp;'}[c] as string)
    )
  const number = globalFormatWithHyphens(row?.officeId, row?.customerNumber)
  return [escape(number), escape(row?.customerName)].filter(Boolean).join(' ')
}

/** A/S 등록·취소 공통 옵션 */
type AsActionOptions = {
  /** 미리 고른 원인 코드(codeIdx). 일괄 버튼처럼 화면에서 선택하는 경우 */
  cause?: any
  /** 확인창에 보여줄 원인 이름 */
  causeName?: string
  /** 원인이 없을 때 선택 모달을 띄운다. 행 단위 버튼처럼 그 자리에서 고르는 경우 */
  promptCause?: boolean
  /** 성공 후 호출부 갱신 */
  onDone?: () => void
}

const AS_MAX_COUNT = 5000

/**
 * A/S 등록. 일괄 버튼과 행 단위 버튼이 함께 쓴다.
 * 행 단위는 rows 에 [row] 하나만 넘기면 된다.
 */
export const registerAs = async (info: any, rows: any[], options: AsActionOptions = {}) => {
  if (!rows || rows.length === 0) {
    await noDataAlert()
    return
  }
  if (rows.length >= AS_MAX_COUNT) {
    await normalAlert(`${AS_MAX_COUNT}개 이상은 한번에 A/S 등록을 할 수 없습니다.`)
    return
  }
  if (_.some(rows, isAsInProgress)) {
    await normalAlert('AS가 진행 중인 수용가가 있습니다.')
    return
  }

  let cause = options.cause
  let confirmed = false

  // 원인을 미리 고르지 않았으면 선택 모달을 띄운다. 이 모달이 확인창을 겸한다.
  if (!cause && options.promptCause) {
    const causeRes = await axiosWithAuth().get(`${envBackHost}/worktype/as/codetype/cause`)
    const picked = await confirmASAlert('A/S 등록', 'info', causeRes, asTargetText(rows))
    if (!picked) return
    cause = picked
    confirmed = true
  }

  if (!cause) {
    await normalAlert('AS 사유를 선택해주세요.')
    return
  }

  if (!confirmed) {
    const text = `${asTargetText(rows)}에 A/S를 등록합니다.${
      options.causeName ? `<br/>원인 : ${options.causeName}` : ''
    }`
    if (!(await confirmTextAlert(text, 'A/S 등록'))) return
  }

  try {
    const res = await axiosWithAuth().post(`${envBackHost}/as`, {
      asList: _.map(rows, toAsRegisterTarget),
      asId: null,
      causeIdx: cause,
      registerId: info?.userId,
    })
    await resultAlert(res.data)
    if (res.data.resultCode === 0) options.onDone?.()
  } catch (e: any) {
    // 네트워크 오류·타임아웃이면 e.response 자체가 없어 알림조차 못 띄우던 문제
    await resultAlert({resultCode: e?.response?.status ?? 500})
  }
}

/** A/S 취소. 일괄 버튼과 행 단위 버튼이 함께 쓴다. */
export const cancelAs = async (info: any, rows: any[], options: AsActionOptions = {}) => {
  if (!rows || rows.length === 0) {
    await noDataAlert()
    return
  }
  if (rows.length >= AS_MAX_COUNT) {
    await normalAlert(`${AS_MAX_COUNT}개 이상은 한번에 A/S 취소를 할 수 없습니다.`)
    return
  }
  if (_.some(rows, (row) => !isAsInProgress(row))) {
    await normalAlert('AS가 진행 중이지 않은 수용가가 존재합니다.')
    return
  }

  if (!(await confirmTextAlert(`${asTargetText(rows)}의 A/S를 취소합니다.`, 'A/S 취소'))) return

  try {
    const res = await axiosWithAuth().put(`${envBackHost}/as/delete`, {
      asList: _.map(rows, toAsTarget),
    })
    await resultAlert(res.data)
    if (res.data.resultCode === 0) options.onDone?.()
  } catch (e: any) {
    await resultAlert({resultCode: e?.response?.status ?? 500})
  }
}

export const getAsList = async (
  office: any,
  cooper: any,
  filter: any,
  {success, fail, loading, count}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${office?.value === 'yit' ? 'all' : office?.value}/${cooper.value}/task/as`,
      {
        params: filter,
      }
    )
    success(response.data.res)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const getAsListCode = async ({success, fail, loading, count}: Callbacks) => {
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/worktype/as/codetype/all`)
    success(response.data.res)
  } catch (error) {
    fail(error)
  } finally {
  }
}
export const putAsUnassign = async (data: any, user: any, {success, fail}: Callbacks) => {
  if (data?.length === 0) {
    await noDataAlert()
    return
  }
  if (
    _.some(
      data,
      (el) =>
        (el.resultIdx !== null && typeof el.resultIdx === 'string') || el.resultIdx === 'number'
    )
  ) {
    await normalAlert('할당 취소할 수 없는 AS가 포함되어 있습니다.')
    return
  }
  if (await confirmAlert('할당취소', 'info')) {
    try {
      const response = await axiosWithAuth().put(`${envBackHost}/as`, {
        asList: data,
        asId: null,
        updateId: user.userId,
      })
      success(response.data)
      await resultAlert(response.data)
    } catch (error: any) {
      fail(error)
      await resultAlert({resultCode: error.response.status})
    }
  } else return
}

export const putAsCancel = async (data: any, {success, fail}: Callbacks) => {
  if (data?.length === 0) {
    await noDataAlert()
    return
  }
  if (
    _.some(
      data,
      (el) =>
        (el.resultIdx !== null && typeof el.resultIdx === 'string') || el.resultIdx === 'number'
    )
  ) {
    await normalAlert('취소할 수 없는 AS가 포함되어 있습니다.')
    return
  }
  if (await confirmAlert('AS취소', 'info')) {
    try {
      const response = await axiosWithAuth().put(`${envBackHost}/as/delete`, {
        asList: data,
      })
      success(response.data)
      await resultAlert(response.data)
    } catch (error: any) {
      fail(error)
      await resultAlert({resultCode: error.response.status})
    }
  } else return
}
export const getAsDetailImage = async (data: any, {success, fail, loading}: Callbacks) => {
  try {
    loading(true)
    const response = await axiosWithAuth().get(`${envBackHost}/task/as/${data}`)

    success(response.data.res)
  } catch (error) {
    fail(error)
  } finally {
    setTimeout(() => {
      loading(false)
    }, 600)
  }
}
export const getRecoveryInfoList = async (
  cooper: any,
  filter: any,
  {success, fail, loading}: Callbacks
) => {
  loading(true)
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${cooper?.value}/recovery/device/list`,
      {
        params: filter,
      }
    )
    success(response.data.res)
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const deleteDisuseDevice = async (data: any, user: any, {success, fail}: Callbacks) => {
  if (await confirmAlert('폐기처리', 'warning')) {
    try {
      const response = await axiosWithAuth().delete(
        `${envBackHost}/recovery/device/disuse/${user?.userId}/${data}`
      )
      success(response.data.res)
      await resultAlert(response.data)
    } catch (error: any) {
      fail(error)
      await resultAlert({resultCode: error.response.status})
    }
  } else return
}

export const putRecycleDevice = async (data: any, user: any, {success, fail}: Callbacks) => {
  if (data?.length === 0) {
    await noDataAlert()
    return
  }
  if (await confirmAlert('재사용', 'warning')) {
    try {
      const response = await axiosWithAuth().put(`${envBackHost}/recovery/device/recycle`, {
        device: data,
        id: user?.userId,
      })
      success(response.data)
      await resultAlert(response.data)
    } catch (error: any) {
      fail(error)
      await resultAlert({resultCode: error.response.status})
    }
  } else return
}
/**
 * account Api
 */
export const getAllOfficeList = async (user: any, {success, fail}: Callbacks) => {
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/office/${user?.officeId}`)
    success(response.data.res)
  } catch (error) {
    fail(error)
  }
}
export const getAccountList = async (office: any, filter: any, {success, fail}: Callbacks) => {
  try {
    const response = await axiosWithAuth().get(
      `${envBackHost}/${office?.value === 'yit' ? 'all' : office?.value}/account`,
      {
        params: filter,
      }
    )
    success(response.data.res)
  } catch (error) {
    fail(error)
  }
}
export const getCooperList = async ({success, fail}: Callbacks) => {
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/cooperation/device`)
    success(response.data.res)
  } catch (error) {
    fail(error)
  }
}
export const getAccountTypeList = async ({success, fail}: Callbacks) => {
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/accounttype`)
    success(response.data.res)
  } catch (error) {
    fail(error)
  }
}
/**
 * Install API
 */

export const getInstallAllCount = async (user: any, {success, fail}: Callbacks) => {
  try {
    const installAvailable = await axiosWithAuth().get(
      `/install/${user?.userId}/customer/assign/count`
    )
    const installComplete = await axiosWithAuth().get(`/install/${user?.userId}/complete/count`)
    const installAs = await axiosWithAuth().get(`/as/${user?.userId}/customer/assign/count`)
    const installAsComplete = await axiosWithAuth().get(`/as/${user?.userId}/complete/count`)
    success({
      installAvailableCount: installAvailable.data.res,
      installCompleteCount: installComplete.data.res,
      installAsCount: installAs.data.res,
      installAsCompleteCount: installAsComplete.data.res,
    })
  } catch (error) {
    fail(error)
  }
}
export const getInstallList = async (
  user: any,
  location: string,
  filter: any,
  {success, fail, loading}: Callbacks
) => {
  loading(true)
  try {
    switch (location) {
      case 'installCustomer':
        await axiosWithAuth()
          .get(`/install/${user?.userId}/customer/assign`, {
            params: filter,
          })
          .then((res) => {
            success(res.data.res)
          })
          .catch((e) => {
            fail(e)
          })
        break
      case 'installDevice':
        await axiosWithAuth()
          .get(`/install/${user?.userId}/device/assign`)
          .then((res) => {
            success(res.data.res)
          })
          .catch((e) => {
            fail(e)
          })
        break
      case 'complete':
        await axiosWithAuth()
          .get(`/install/${user?.userId}/complete`, {
            params: filter,
          })
          .then((res) => {
            success(res.data.res)
          })
          .catch((e) => {
            fail(e)
          })
        break
      case 'as':
        await axiosWithAuth()
          .get(`/as/${user?.userId}/list`)
          .then((res) => {
            success(res.data.res)
          })
          .catch((e) => {
            fail(e)
          })
        break
      case 'asComplete':
        await axiosWithAuth()
          .get(`/as/${user?.userId}/complete`, {
            params: filter,
          })
          .then((res) => {
            success(res.data.res)
          })
          .catch((e) => {
            fail(e)
          })
        break
      default:
        break
    }
  } catch (e) {
    fail(e)
  } finally {
    loading(false)
  }
}
export const getPosition = async ({success, fail}: Callbacks) => {
  if ('geolocation' in navigator) {
    const permissionStatus = await navigator.permissions.query({name: 'geolocation'})
    if (permissionStatus.state === 'denied') {
      fail('위치 정보 접근이 거부되었습니다. 설정에서 권한을 허용해주세요.')
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        success(position)
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            fail('위치 정보 접근이 거부되었습니다. 설정에서 권한을 허용해주세요.')
            break
          case error.POSITION_UNAVAILABLE:
            fail('위치 정보를 사용할 수 없습니다.')
            break
          case error.TIMEOUT:
            fail('위치 정보 요청 시간이 초과되었습니다.')
            break
          default:
            fail('알 수 없는 오류가 발생했습니다.')
        }
      },
      {enableHighAccuracy: true, timeout: 10000, maximumAge: 0}
    )
  } else {
    fail('위치정보를 사용할 수 없습니다.')
  }
}
const applyBrightnessAndContrast = (
  imageData: any,
  brightness: any,
  contrast: any,
  rotate: any
) => {
  const canvas = document.createElement('canvas')
  const context: any = canvas.getContext('2d')
  const image = new Image()

  return new Promise((resolve, reject) => {
    image.onload = () => {
      canvas.width = image.width
      canvas.height = image.height
      context.translate(canvas.width / 2, canvas.height / 2)

      // 회전 각도 설정 (단위는 라디안이므로 각도를 라디안으로 변환)
      context.rotate((rotate * Math.PI) / 180)

      // 원래 위치로 다시 이동
      context.translate(-canvas.width / 2, -canvas.height / 2)

      // context.filter = `brightness(${brightness}%) contrast(${contrast}%)`
      context.drawImage(image, 0, 0)
      resolve(canvas.toDataURL('image/jpeg'))
    }

    image.onerror = reject
    image.src = imageData
  })
}
/**
 * 이미지 다운로드.
 *
 * @param imageUrl  이미지 경로. 서버 상대경로(filePath)면 envImagePath 를 붙이고,
 *                  이미 절대 URL 이거나 크롭 결과인 data/blob URL 이면 그대로 사용한다.
 * @param device    파일명 앞에 붙는 식별자 (수용가명, 단말기 시리얼 등 호출부마다 다름)
 * @param fileSuffix 파일명 뒷부분. 설치는 'install', A/S 는 'as_install'.
 */
export const imageDownload = async (
  imageUrl: any,
  brightness: any,
  contrast: any,
  rotate: any,
  device: string,
  fileSuffix: string = 'install'
) => {
  if (!imageUrl) {
    await ErrorAlert('이미지 경로가 없습니다. 단말기를 확인해주세요.')
    return
  }

  const isAbsolute = /^(https?:|data:|blob:)/i.test(String(imageUrl))
  const source = isAbsolute ? String(imageUrl) : envImagePath + imageUrl

  let blob: Blob
  try {
    const res = await fetch(source, {method: 'GET'})
    const contentType = res.headers.get('content-type') ?? ''

    /* 이미지 조회에 실패해도 백엔드는 200 으로 에러 봉투(JSON)를 내려준다.
       ex) {"res":null,"message":"잘못된 파일 혹은 양식입니다.","resultCode":30}
       따라서 상태 코드만으로는 판별할 수 없고 Content-Type 을 함께 봐야 한다. */
    if (!res.ok || !contentType.startsWith('image/')) {
      const body = contentType.includes('json') ? await res.json().catch(() => null) : null
      await ErrorAlert(body?.message || '이미지를 찾을 수 없습니다. 단말기 상태를 확인해주세요.')
      return
    }
    blob = await res.blob()
  } catch {
    await ErrorAlert('이미지를 불러오지 못했습니다. 네트워크 상태를 확인해주세요.')
    return
  }

  const reader = new FileReader()
  reader.onloadend = () => {
    applyBrightnessAndContrast(reader.result, brightness, contrast, rotate)
      .then((modifiedImageUrl: any) => {
        const a = document.createElement('a')
        a.href = modifiedImageUrl
        a.download = `${device}_${fileSuffix}.jpg`
        document.body.appendChild(a)
        a.click()
        setTimeout(() => {
          window.URL.revokeObjectURL(modifiedImageUrl)
          a.remove()
        }, 60000)
      })
      .catch(async () => {
        await ErrorAlert('이미지 처리 중 오류가 발생했습니다.')
      })
  }
  reader.readAsDataURL(blob)
}
/**
 * silent: 사용자가 누른 게 아니라 화면이 알아서 부르는 경우. 결과 알림을 띄우지 않는다.
 */
export const imageRefresh = async (
  device: any,
  {success, fail, loading}: Callbacks,
  {silent = false}: {silent?: boolean} = {}
) => {
  loading(true)
  if (device.imei === null) {
    loading(false)
    if (!silent) await ErrorAlert('이미지를 불러 올 수 없는 상태입니다. 단말기를 확인 해주세요')
    return
  }
  try {
    const response = await axiosWithAuth().get(`install/${device?.imei}/send/${device?.idxDate}`)

    if (response.data.res !== null) {
      success(response.data.res)
      if (!silent) await SuccessAlert(response.data.res.message)
    } else if (!silent) {
      await noNewImageAlert(
        '이미지를 불러 올 수 없는 상태입니다.<br/> 단말기 ON/OFF를 다시 진행해주세요.'
      )
    }
  } catch (error) {
    fail(error)
  } finally {
    loading(false)
  }
}
export const installComplete = async (data: any, {success, fail, loading}: Callbacks) => {
  loading(true)
  try {
    const response = await axiosWithAuth().post(`install`, data)
    success(response.data.res)
    console.log(response)
    await resultAlert(response.data)
  } catch (error: any) {
    fail(error)
    await resultAlert({resultCode: error.response.status})
  } finally {
    loading(false)
  }
}
export const getSolutionList = async ({success, fail}: Callbacks) => {
  try {
    const response = await axiosWithAuth().get(`${envBackHost}/worktype/as/codetype/result`)
    success(response.data.res)
  } catch (e) {
    fail(e)
  }
}

export const requestAsComplete = async (
  type: string,
  data: any,
  {success, fail, loading}: Callbacks
) => {
  loading(true)
  try {
    switch (type) {
      case 'deviceChange':
        const deviceChangeResponse = await axiosWithAuth().post(
          `${envBackHost}/as/${data?.idx}/devicechange/complete`,
          data
        )
        success(deviceChangeResponse.data)
        await resultAlert(deviceChangeResponse.data)
        break
      case 'efosChange':
        const efosChangeResponse = await axiosWithAuth().post(
          `${envBackHost}/as/${data?.idx}/efos/complete`,
          data
        )
        success(efosChangeResponse.data)
        await resultAlert(efosChangeResponse.data)
        break
      case 'normalChange':
        const normalChangeResponse = await axiosWithAuth().post(
          `${envBackHost}/as/${data?.idx}/clear/complete`,
          data
        )
        success(normalChangeResponse.data)
        await resultAlert(normalChangeResponse.data)
        break
    }
  } catch (error: any) {
    fail(error)
    await resultAlert({resultCode: error.response.status})
  } finally {
    loading(false)
  }
}
export const notInstallable = async (data: any, {success, fail, loading}: Callbacks) => {
  loading(true)
  if (await confirmAlert('설치불가', 'info')) {
    try {
      const response = await axiosWithAuth().post(`${envBackHost}/install/not-available`, data)
      success(response.data.res)
      await resultAlert(response.data)
    } catch (error: any) {
      fail(error)
      await resultAlert({resultCode: error.response.status})
    } finally {
      loading(false)
    }
  } else {
    loading(false)
    return
  }
}
export const customerUninstall = async (data: any, {success, fail, loading}: Callbacks) => {
  loading(true)
  if (await confirmAlert('설치취소', 'info')) {
    try {
      const response = await axiosWithAuth().delete(`/install/${data}`)
      success(response.data)
      await resultAlert(response.data)
    } catch (error: any) {
      fail(error)
      await resultAlert({resultCode: error.response.status})
    } finally {
      loading(false)
    }
  } else {
    loading(false)
    return
  }
}

export const saeolDataPost = async (formData: any, officeInfo: any) => {
  const _res = await axios.post(
    `${chargeBackHost}/saeol/?office_code=${
      officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
    }`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return _res
}

export const saeolDataEumseongPost = async (data: any, date: any, officeInfo: any) => {
  const _res = await axios.post(
    `${chargeBackHost}/saeol/?office_code=${
      officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
    }`,
    {
      data: data,
      date: date,
    },
    {
      headers: {
        'Content-Type': 'application/json', // JSON 데이터 전송을 위해 Content-Type 변경
      },
    }
  )
  return _res
}

export const wimsDataHwasunPost = async (formData: any, date: any, officeInfo: any) => {
  const _res = await axios.post(
    `${chargeBackHost}/wims/?office_code=${
      officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
    }&check_date=${date}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return _res
}

export const saeolTrsusrPost = async (formData: any, date: any, officeInfo: any, userId: any) => {
  const _res = await axios.post(
    `${chargeBackHost}/api/upload/?office_code=${
      officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
    }&check_date=${date}&update_id=${userId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return _res
}

export const wimsDataPost = async (formData: any, date: any, officeInfo: any) => {
  const _res = await axios.post(
    `${chargeBackHost}/wims/?office_code=${
      officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
    }&date=${date}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return _res
}
export const cheonanTrsusrDataPost = async (
  formData: any,
  date: any,
  officeInfo: any,
  userId: any
) => {
  const _res = await axios.post(
    `${chargeBackHost}/api/upload/?office_code=${
      officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
    }&check_date=${date}&update_id=${userId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return _res
}

export const crebizDataPost = async (formData: any, date: any, officeInfo: any) => {
  const _res = await axios.post(
    `${chargeBackHost}/crebiz/?office_code=${
      officeInfo?.value === 'yit' ? 'all' : officeInfo?.value
    }&date=${date}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return _res
}

/**
 *  이미지 보정 작업용 get, post
 */
export const getImageRevisionData = async (data: any) => {
  try {
    const res = await axios.get(`${envBackHost}/device/imagesrevision/${data?.imei}`)

    return res.data
  } catch (error: any) {
    console.log('error', error)
  } finally {
  }
}

export const postImageRevisionData = async (data: any) => {
  const formData = new FormData()
  formData.append('image', data.image)
  formData.append(
    'imageRevisionModel',
    new Blob([JSON.stringify(data.imageRevisionModel)], {type: 'application/json'})
  )

  try {
    const res = await axios.post(`${envBackHost}/device/imagerevision`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return res.data
  } catch (error: any) {
    console.log('error', error)
  } finally {
  }
}
